module.exports = __webpack_public_path__ + "media/img/corporate/event-showcase-f597649f916c6bb0782ef0d186fa7c2e.png";